export default __webpack_public_path__ + "static/media/schedule.66d073e7.svg";